import { createSlice } from '@reduxjs/toolkit'
import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'

const initialState = {
  visible: false,
  isSubmitting: false,
  previewVisible: false,
  isLoading: false,
  loadingError: undefined,
  campaigns: [],
  form: {
    traceUrlYn: 'N',
  },
  preview: {
    traceUrlYn: 'N',
  },
}

export const showCampaignTraceUrlEdit = createAxiosThunk(
  'dashboard/showCampaignTraceUrlEdit',
  campaignIds => api.ad.getCampaignsById(campaignIds)
)

export const updateCampaignsTraceUrl = createAxiosThunk(
  'dashboard/updateCampaignsTraceUrl',
  (noArgs, { getState }) => {
    const {
      campaigns,
      form: { traceUrlYn },
    } = getState().dashboard.operation.campaignTraceUrlEdit
    return api.ad.patchCampaignsTraceUrl({
      campaignIds: campaigns.map(({ id }) => id),
      traceUrlYn,
    })
  }
)
const campaignTraceUrlEditSlice = createSlice({
  name: 'dashboard/campaignTraceUrlEdit',
  initialState,

  reducers: {
    hideCampaignTraceUrlEdit: () => initialState,
    setTraceUrlYn: (state, { payload }) => {
      state.form.traceUrlYn = payload
    },
    showPreview: state => {
      state.preview.traceUrlYn = state.form.traceUrlYn
      state.previewVisible = true
    },
  },

  extraReducers: builder => {
    builder.addCase(showCampaignTraceUrlEdit.pending, state => {
      state.isLoading = true
      state.visible = true
    })

    builder.addCase(showCampaignTraceUrlEdit.rejected, (state, { payload }) => {
      state.loadingError = payload
      state.isLoading = false
    })

    builder.addCase(
      showCampaignTraceUrlEdit.fulfilled,
      (state, { payload }) => {
        const campaigns = payload.campaigns.map(({ id, name, traceUrlYn }) => ({
          id,
          name,
          traceUrlYn,
        }))
        state.campaigns = campaigns
        state.form.traceUrlYn = campaigns.some(item => item.traceUrlYn === 'Y')
          ? 'Y'
          : 'N'
        state.visible = true
        state.isLoading = false
      }
    )

    builder.addCase(updateCampaignsTraceUrl.pending, state => {
      state.isSubmitting = true
    })

    builder.addCase(updateCampaignsTraceUrl.fulfilled, state => {
      state.isSubmitting = false
    })

    builder.addCase(updateCampaignsTraceUrl.rejected, state => {
      state.isSubmitting = false
    })
  },
})
export const { hideCampaignTraceUrlEdit, showPreview, setTraceUrlYn } =
  campaignTraceUrlEditSlice.actions
export default campaignTraceUrlEditSlice.reducer
